// extracted by mini-css-extract-plugin
module.exports = {"noScrolling":"SubmitButton_noScrolling__btE2B","submitButton":"SubmitButton_submitButton__7VvBY","tape":"SubmitButton_tape___zm41"};